import * as React from "react";
import PropTypes from "prop-types";
import { Title, Field, Control, Button } from "rbx";
import PrintBarcodeForm from "../PrintBarcodeForm";

const { REACT_APP_REPORT_BASE_URL } = process.env;

function PrintBarcodeModal({
  ItemNo,
  Multiplier,
  Dim1,
  Dim2,
  Dim3,
  onComplete
}) {
  const [inputs, setInputs] = React.useState({
    ItemNo,
    Multiplier,
    Dim1,
    Dim2,
    Dim3
  });

  const handleSubmit = e => {
    e.preventDefault();
    const params = Object.keys(inputs)
      .map(
        (param, index) =>
          inputs[param] &&
          `Param${index ? index + 1 : ""}=${param}&ParamValue${
            index ? index + 1 : ""
          }=${inputs[param]}`
      )
      .filter(Boolean)
      .join("&");

    const reportUrl = `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Inventory%20Item%20Bar%20Code%20Label&${params}`;
    window.open(reportUrl, "_blank");
    onComplete();
  };

  const handleChange = (name, value) => {
    console.log({ name, value });
    setInputs(prev => ({ ...prev, [name]: value }));
  };

  const isDisabled = false;
  return (
    <form id="print-barcode" onSubmit={handleSubmit}>
      <header className="page-head">
        <div className="page-head-start">
          <Title size={4}>Print Barcode</Title>
        </div>
        <div className="page-head-end">
          <Field kind="group">
            <Control>
              <Button size="small" type="button" onClick={() => onComplete()}>
                Cancel
              </Button>
            </Control>
            <Control>
              <Button color="primary" size="small" type="submit">
                Submit
              </Button>
            </Control>
          </Field>
        </div>
      </header>
      <hr />
      <PrintBarcodeForm
        disabled={isDisabled}
        inputs={inputs}
        onChange={handleChange}
      />
      <hr />
      {/* <pre>{JSON.stringify(inputs, null, 2)}</pre> */}
    </form>
  );
}

PrintBarcodeModal.propTypes = {
  ItemNo: PropTypes.string,
  Multiplier: PropTypes.string,
  Dim1: PropTypes.string,
  Dim2: PropTypes.string,
  Dim3: PropTypes.string,
  onComplete: PropTypes.func
};
PrintBarcodeModal.defaultProps = {
  ItemNo: "",
  Multiplier: "1",
  Dim1: "",
  Dim2: "",
  Dim3: "",
  onComplete: () => {}
};
export default PrintBarcodeModal;
